import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import DetailBillingHistory from "../../components/Billing/DetailBillingHistory";
import AdminLayout from "../../layouts/AdminLayout";

export default function DetailBillingHistoryPage() {
  const { user } = useContext(AuthContext);
  const nombreUsuario = user?.nombre || "Usuario";
  return (
    <AdminLayout nombreUsuario={nombreUsuario}>
      <div className="mt-8 px-4 md:px-8">
        <DetailBillingHistory />
      </div>
    </AdminLayout>
  );
}
